/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 */

/* Styles */
import 'react-datetime/css/react-datetime.css';

import React from 'react';
import moment from 'moment';
import Datetime from 'react-datetime';
import ResetFilterComponent from './ResetFilterComponent.jsx';
import ToolTip from '../../common/ToolTip.js';

class DateTimeRangeComponent extends React.Component {
    constructor(props) {
        super(props)
        let Dyn = this.props.Dyn;
        /**
         * set the range using leftNumber and rightNumber from attribute statsPreFilter
         * and initial values for the indicators by reading it from attribute stats
         * Its based on the range calculated by the scale
         */
        var filter = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeObj.id ),
            currentMin = (filter?.numeric) ? filter.numeric.min : this.props.attributeObj.statsPreFilter.min,
            currentMax = (filter?.numeric) ? filter.numeric.max : this.props.attributeObj.statsPreFilter.max;

      this.minDate = React.createRef();
      this.maxDate = React.createRef();
      this.state = {
          leftNumber: currentMin,
          rightNumber: currentMax,
          storedNumber: currentMin,
          mode: this.props.mode
      };
    }


  // Typed conditions cannot go out of bounds, but they can cross
  typedConditionsMet = (state) => {
    // left needs to be less than right
    return moment(state.leftNumber) <= moment(state.rightNumber);
  }

  getOtherDirection = (thisDirection) => {

    var directions = ["left", "right"];
    var otherIndex = (directions.indexOf(thisDirection) + 1) % 2;
    return directions[otherIndex];
  }

  onChange = ( key, e ) => {

    var   stateObject = {},
      targetClassName = key,
            direction = targetClassName.match(/(\w+)Number/)[1],
       otherDirection = this.getOtherDirection(direction),
           targetValue = e, //e._d; //e.target.value;
           isYearMonth = this.props.mode === 'yearMonth' || this.props.mode === 'monthYear';

    // onChange callback recieves moment object if its valid, else string
    if( e && typeof(e) === 'object' ) {
      // e is momentjs object, and _d.valueOf() gives timestamp
      stateObject[targetClassName] = targetValue._d.valueOf();
    } else if (targetValue === "") {
      stateObject[targetClassName] = "";
      stateObject.storedNumber = this.state[targetClassName];
      this.setState(stateObject);
      return;
    } else
      return;

    var otherNumber = otherDirection + "Number",
        wrongInput = false;
    if (otherNumber === 'leftNumber'){
        stateObject[otherNumber] = this.minDate.current.props.value;
    } else {
        stateObject[otherNumber] = this.maxDate.current.props.value;
    }
    // stateObject[otherNumber] = this.state[otherNumber];
    if (!this.typedConditionsMet(stateObject)){
      // if left is not less than right, don't do anything
      // highlight the item.
      wrongInput = true;
      // stateObject[otherNumber] = stateObject[targetClassName];
    } else {
      // stateObject = this.addPositionsFromNumbers(stateObject);
      this.setState(stateObject);
    }

    if( !wrongInput ){

      // message to parent to rerender
      this.props.handleChange({
          filterChanged: true,
          dataType: 'numerical',
          subType: this.props.mode,
          filtered: {
              min: isYearMonth ? this.props.Dyn.dataUtil.dateSerialToMonthYear(stateObject.leftNumber) : stateObject.leftNumber,
              max: isYearMonth ? this.props.Dyn.dataUtil.dateSerialToMonthYear(stateObject.rightNumber) : stateObject.rightNumber
          }
      });
    }
  }

  onBlur = ( key, e ) => {

    // check the classname and value in obj.target
    var stateObject = {};
    var targetClassName = key;
    if (e._d === "")
      stateObject[targetClassName] = this.state.storedNumber;
    this.setState(stateObject);

  }

  onFocus = ( e ) => {

    // make the insert left align
    var   stateObject = {},
      targetClassName = e.target.className,
            direction = targetClassName,
                value = e.target.value;
    stateObject[targetClassName] = '';
    stateObject.storedNumber = this.state[targetClassName];
    this.setState(stateObject);
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  render = () => {

    var leftNumber = this.state.leftNumber,
        rightNumber = this.state.rightNumber;

    if( this.props.resetFilter ){
      leftNumber = this.props.attributeObj.statsPreFilter.min;
      rightNumber = this.props.attributeObj.statsPreFilter.max;
    }

    var dateFormat = true,
        timeFormat = true,
        key = 'datetime';

    if ( this.props.mode == 'date' ) {
      dateFormat = 'YYYY-MM-DD';
      timeFormat = false;
      key = 'date';
    } else if (this.props.mode == 'time' ) {
      dateFormat = false;
    //   timeFormat = 'HH:mm:ss';
      key = 'time';
    } else if (this.props.mode == 'yearMonth' || this.props.mode == 'monthYear') {
        // if Number is already updated, trying to get monthYear will return NaN
        if (this.props.Dyn.dataUtil.monthYearSerialToDate(leftNumber)){
            leftNumber = this.props.Dyn.dataUtil.monthYearSerialToDate(leftNumber);
        }
        if (this.props.Dyn.dataUtil.monthYearSerialToDate(rightNumber)) {
            rightNumber = this.props.Dyn.dataUtil.monthYearSerialToDate(rightNumber);
        }
        dateFormat = 'YYYY-MM';
        timeFormat = false;
        key = 'yearMonth';
    } else if (this.props.mode == 'datetime') {
        dateFormat = 'YYYY-MM-DD';
        timeFormat = 'hh:mm:ss A';
        key = 'datetime';
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if( typeof(leftNumber) === 'undefined' || typeof(rightNumber) === 'undefined')
    {
      return (
        <div className="tde-numeric-component">
          <div className="tde-m-2 tde-text-error tde-err-msg-text-color">{this.getLoc('No valid numeric value for the attribute.')}</div>
        </div>
      );
    } else {
      return (
        <div className="tde-numeric-component tde-pt-4 tde-mt-4 tde-divider-top tde-divider-bottom tde-pb-4">
            <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                <div className="tde-row">
                    <div className="tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Filter Range') }<ToolTip tip={this.getLoc('Set minimum and maximum values')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                    { this.props.isFiltered && <ResetFilterComponent value={ this.getLoc('Reset') } handleChange={this.props.handleChange} attributeObj={ this.props.attributeObj } isFiltered={ this.props.isFiltered }/>}
                </div>
                </div>
                    <div className="tde-row tde-my-2">
                        <div className="tde-label tde-mb-2">{ this.getLoc('Min') }</div>
                        <Datetime value={leftNumber}
                            key={key}
                            ref={this.minDate}
                            className="tde-input tde-input-parent"
                            dateFormat={dateFormat}
                            timeFormat={timeFormat}
                            onChange={this.onChange.bind(this, 'leftNumber')}
                            onBlur={this.onBlur.bind(this, 'leftNumber')} />
                    </div>
                    <div className="tde-row tde-my-2">
                        <div className="tde-label tde-mb-2">{ this.getLoc('Max') }</div>
                            <Datetime value={rightNumber}
                            key={key}
                            ref={this.maxDate}
                            className="tde-input tde-input-parent"
                            dateFormat={dateFormat}
                            timeFormat={timeFormat}
                            onChange={this.onChange.bind(this, 'rightNumber')}
                            onBlur={this.onBlur.bind(this, 'rightNumber')} />
                </div>
            </div>
        </div>
      );
    }
  }
}

export default DateTimeRangeComponent;
